import { render, staticRenderFns } from "./side_bar.vue?vue&type=template&id=05a5c63d&scoped=true&"
import script from "./side_bar.vue?vue&type=script&lang=js&"
export * from "./side_bar.vue?vue&type=script&lang=js&"
import style0 from "./side_bar.vue?vue&type=style&index=0&id=05a5c63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a5c63d",
  null
  
)

export default component.exports